class CheckBoxListField extends React.Component {
    constructor(props) {
        super(props);
    }

    onFieldChanged(option, event) {
        let value = this.props.value;

        if (value != null && value != "") {
            if (value.charAt(0) != "|")
                value = "|" + value;
            if (value.charAt(value.length - 1) != "|")
                value = value + "|";
        }

        if (event.target.checked) {
            if (value.charAt(value.length - 1) == "|")
                value = value + option + "|";
            else
                value = value + "|" + option + "|";
        }
        else {
            value = value.replace(option + "|", "");
        }

        if (value == "|") {
            value = "";
        }

        this.props.onFieldChanged(value);
    }

    render() {
        var style = {};
        var value = this.props.value;

        if (value != null && value != "") {
            if (value.charAt(0) != "|")
                value = "|" + value;
            if (value.charAt(value.length - 1) != "|")
                value = value + "|";
        }

        if (this.props.stacklabel) {
            style.margin = "2px 10px 0 10px";
        }

        let checkboxFields = [];
        for (let i = 0; i < this.props.checkboxes.length; i++) {
            let option = this.props.checkboxes[i];
            let bOptionChecked = value.indexOf("|" + option.value + "|") >= 0;
            let bPutBreak = i % 2 == 1;
            let style = {};
            if (i % 2 == 0) {
                style = { marginRight: '18%' };
            }

            checkboxFields.push(
                <div key={i}>
                    <label className="" style={style}>
                        <input
                            key={option.value + i}
                            disabled={this.props.disabled ? true : false}
                            type="checkbox"
                            checked={bOptionChecked}
                            value={option.value}
                            onChange={(e) => { this.onFieldChanged(option.value, e); }}
                            className={this.props.error == true ? "inputError sub-free-radio" : "sub-free-radio"}
                        />
                        {option.text}
                    </label>
                </div>
            );
        }

        //build the className for the radios element
        var checkboxlistClassName = this.props.feRequired ? "fe-required-field" : "";

        var label = "";
        if (!this.props.hasLabel) {
            label = <span>{this.props.isRequired ? <span className="required-red"> *</span> : ""} {this.props.label || this.props.placeholder}</span>;
        }

        return (
            <div>
                <div className="label">
                    {label}
                    {this.props.stacklabel ? <br /> : ""}
                    <div className={checkboxlistClassName}>
                        {checkboxFields}
                    </div>
                </div>
                <p style={{ margin: '0' }} className="validationError">
                    <span>{this.props.errorText}</span>
                </p>
            </div>
        );
    }
}

export default CheckBoxListField;
global.CheckBoxListField = CheckBoxListField;